module.exports = __webpack_public_path__ + "static/9.Risk Disclosure of China Northbound Trading-4c33d89852aceca2afa133f020bd2eee.pdf";